import store from '@/store'
let intervalToken = null;

export function getLoginTokenExpireMinute() {
  if (store.state.tokenInfo == null){
    return -1;
  }
  let tsExpire = store.state.tokenInfo.expire_timestamp;
  let tsNow = Date.parse(new Date()) / 1000;
  let result = parseInt((tsExpire - tsNow)/60);
  return result;
}

export function checkTokenExpire() {
    if (intervalToken == null){
      intervalToken = setInterval(()=>{
        if (getLoginTokenExpireMinute() < 30){
          store.commit('setLoginUserInfo', null);
          store.commit('setTokenInfo', null);
          clearInterval(intervalToken);
        }
      },60000)
    }
}



// WEBPACK FOOTER //
// ./src/common/common.js